import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const StaffPriorityDialog = ({ open, onClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} disableEscapeKeyDown maxWidth="sm">
            <DialogTitle>
                {t("Staff Priority Information")}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    {t("If you answer “Yes,” your child may get priority in the lottery. This does not guarantee a seat.")}
                </Typography>

                <Typography variant="h6" mt={2}>{t("Who counts as certified staff")}</Typography>
                <List dense>
                    <ListItem><ListItemText primary={t("✔ A teacher employed by iLearn Schools")} /></ListItem>
                    <ListItem><ListItemText primary={t("✔ A certified support personnel employed by iLearn Schools")} /></ListItem>
                    <ListItem><ListItemText primary={t("✔ A instructional support personnel employed by iLearn Schools")} /></ListItem>
                </List>

                <Typography variant="body2" mt={2}>
                    {t("We will ask for the work email of the employed parent or guardian so we can confirm employment.")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    {t("Got it")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default StaffPriorityDialog;
